<template>
  <div
    class="bg-white rounded-xl border border-untitled-gray-100 shadow-sm hover:shadow-md transition-shadow duration-150 p-4 flex flex-col gap-2"
  >
    <div class="flex items-start justify-between gap-2">
      <p
        class="text-base font-semibold text-untitled-gray-800 capitalize break-words min-w-0"
      >
        {{ reminder.name }}
      </p>
      <ExclamationCircleIcon
        class="w-5 h-5 shrink-0"
        :class="isOverdue ? 'text-rose-500' : 'text-amber-400'"
        :aria-label="isOverdue ? 'Overdue' : 'Due soon'"
      />
    </div>

    <div
      class="text-sm text-untitled-gray-500 line-clamp-2"
      v-html="formattedText"
    />

    <p class="text-sm text-untitled-gray-400">{{ startDate }}</p>

    <button
      type="button"
      class="self-start text-sm font-semibold text-app-primary hover:text-app-secondary underline underline-offset-2"
      @click="handleClickView"
    >
      View Details
    </button>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { defineProps } from "vue";
import { ExclamationCircleIcon } from "@heroicons/vue/solid";
import { useRouter } from "vue-router";
import dayjs from "dayjs";
import {
  formatText,
  modifiedDescription,
} from "@/composable/reminder/modified-description";

const props = defineProps({
  reminder: {
    type: Object,
    required: true,
  },
  date: {
    type: String,
    default: "",
  },
  time: {
    type: String,
    default: "",
  },
  startDate: {
    type: String,
  },
});

const router = useRouter();

const reminder = computed(() => props.reminder);
const startDate = computed(() => props.startDate);

const isOverdue = computed(() => {
  const assignedDateTime = reminder.value.assignedDateTime;
  if (!assignedDateTime || assignedDateTime === "No date") {
    return false;
  }
  return dayjs(assignedDateTime).isBefore(dayjs());
});

const handleClickView = () => {
  router.push({ name: "reminders", query: { id: reminder.value.id } });
};

const description = computed(() => {
  return modifiedDescription(reminder.value);
});

const formattedText = computed(() => {
  return formatText(description.value, reminder.value.type);
});
</script>

<style scoped></style>
